import React, { useState } from "react";
import {
  Dialog as MUIDialog,
  DialogContent,
  Typography,
  Grid,
} from "@mui/material";
import { ComponentHeader, TextField } from "../../../../components";
import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../../css components/Button";
import { useAxios } from "../../../../hooks";
import { useDispatch } from "react-redux";
import { alert } from "../../../../redux/slices/alertSlice";

export default function ThresholdDialog({
  dialogState,
  setDialogState,
  brandID,
  setFormData,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();

  const [message, setMessage] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setDialogState((prev) => ({
      state: false,
      data: prev.data,
    }));
  };

  const isValidNumber = (value) => {
    const number = Number(value);
    return Number.isInteger(number) && number >= 1 && number <= 5;
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setDialogState((prev) => ({
      ...prev,
      data: value,
    }));
    setMessage(value !== "" && !isValidNumber(value));
  };

  const handleThreshold = async () => {
    setLoading(true);
    try {
      const response = await axios({
        url: "/brand/campaignThreshold",
        disableRedirect: true,
        method: "POST",
        data: {
          brand_id: brandID,
          threshold_value: parseInt(dialogState.data, 10),
        },
      });

      if (response.status) {
        setFormData((prev) => ({
          ...prev,
          threshold: parseInt(dialogState.data, 10),
        }));
        dispatch(
          alert({
            type: "success",
            message: response.message.displayMessage,
          })
        );
        handleClose();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <MUIDialog
      open={dialogState.state}
      onClose={handleClose}
      sx={{ "& .MuiDialog-paper": { minWidth: 400 } }}
    >
      <DialogContent>
        <Grid container spacing={2}>
          <Grid size={12}>
            <ComponentHeader title="Add Threshold" />
            <Typography variant="caption" sx={{ opacity: 0.6 }}>
              Add threshold i.e. how many campaigns a user can lock if they are
              not active
            </Typography>
          </Grid>

          <Grid size={12}>
            <TextField
              size="small"
              name="threshold"
              label="Threshold"
              value={dialogState.data}
              error={message}
              helperText={message ? "Must be an integer between 1 and 5" : ""}
              onChange={handleChange}
            />
          </Grid>

          <Grid size />

          <Grid size>
            <CancelButton onClick={handleClose} variant="outlined">
              Cancel
            </CancelButton>
          </Grid>

          <Grid size>
            <PrimaryLoadingButton
              disabled={message || !dialogState.data}
              loading={loading}
              onClick={handleThreshold}
              variant="contained"
            >
              Save
            </PrimaryLoadingButton>
          </Grid>
        </Grid>
      </DialogContent>
    </MUIDialog>
  );
}
